var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "#FFB02E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08533 6.07916C6.71485 5.89392 6.26434 6.04409 6.0791 6.41457C5.89386 6.78505 6.04403 7.23556 6.41451 7.4208L8.07287 8.24998L6.41451 9.07916C6.04403 9.2644 5.89386 9.71491 6.0791 10.0854C6.26434 10.4559 6.71485 10.606 7.08533 10.4208L10.0853 8.9208C10.3394 8.79376 10.4999 8.53406 10.4999 8.24998C10.4999 7.9659 10.3394 7.7062 10.0853 7.57916L7.08533 6.07916Z",
    fill: "#402A32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9145 6.07916C17.285 5.89392 17.7355 6.04409 17.9208 6.41457C18.106 6.78505 17.9559 7.23556 17.5854 7.4208L15.927 8.24998L17.5854 9.07916C17.9559 9.2644 18.106 9.71491 17.9208 10.0854C17.7355 10.4559 17.285 10.606 16.9145 10.4208L13.9145 8.9208C13.6605 8.79376 13.5 8.53406 13.5 8.24998C13.5 7.9659 13.6605 7.7062 13.9145 7.57916L16.9145 6.07916Z",
    fill: "#402A32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5C4.5 19.5 4.5 12 4.5 12H19.5C19.5 12 19.5 19.5 12 19.5Z",
    fill: "#BB1D80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 13.125H6.375C5.75368 13.125 5.25 12.6213 5.25 12H18.75C18.75 12.6213 18.2463 13.125 17.625 13.125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunny);
export default __webpack_public_path__ + "static/media/funny.29f86cd9.svg";
export { ForwardRef as ReactComponent };